import React, { useState, useEffect } from "react";
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import SalesPage from "./SalesPage";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { defaultContent, defaultStyles } from '../AdminPage/components/SalesPageCustomizer';
import { toast } from 'react-hot-toast';

const useStyles = makeStyles((theme) => ({
  loading: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#1a1a1a'
  },
  loadingText: {
    color: 'white',
    textAlign: 'center'
  }
}));

export default function SalesPagePreview() {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [stagingContent, setStagingContent] = useState(null);
  const [stagingStyles, setStagingStyles] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadStagingVersion = async () => {
      try {
        console.log('Loading staging version...');
        const db = getFirestore();
        
        // Only load from staging documents
        const [stylesDoc, contentDoc] = await Promise.all([
          getDoc(doc(db, 'siteConfig', 'salesPageStylesStaging')),
          getDoc(doc(db, 'siteConfig', 'salesPageContentStaging'))
        ]);

        console.log('Staging styles exists:', stylesDoc.exists());
        console.log('Staging content exists:', contentDoc.exists());

        // Get the staging data
        const stylesData = stylesDoc.exists() ? stylesDoc.data() : defaultStyles;
        const contentData = contentDoc.exists() ? contentDoc.data() : defaultContent;

        console.log('Loaded staging styles:', stylesData);
        console.log('Loaded staging content:', contentData);

        // Set the staging data with proper merging of defaults
        setStagingStyles({
          ...defaultStyles,
          ...stylesData,
          textColors: {
            ...defaultStyles.textColors,
            ...(stylesData.textColors || {})
          }
        });

        setStagingContent({
          ...defaultContent,
          ...contentData,
          sectionOrder: {
            ...defaultContent.sectionOrder,
            ...(contentData.sectionOrder || {})
          },
          visibleSections: {
            ...defaultContent.visibleSections,
            ...(contentData.visibleSections || {})
          }
        });

        setLoading(false);
        toast.success('Loaded staging version');
      } catch (error) {
        console.error('Error loading staging version:', error);
        setError('Error loading staging version. Please try again.');
        setLoading(false);
        toast.error('Failed to load staging version');
      }
    };

    loadStagingVersion();
  }, []);

  if (loading) {
    return (
      <div className={classes.loading}>
        <CircularProgress />
        <div className={classes.loadingText}>Loading staging version...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={classes.loading}>
        <div className={classes.loadingText}>
          {error}
        </div>
        <button 
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            backgroundColor: '#f50057',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  // If we have no content or styles, show an error
  if (!stagingContent || !stagingStyles) {
    return (
      <div className={classes.loading}>
        <div className={classes.loadingText}>
          No staging version available. Please save changes to staging first.
        </div>
      </div>
    );
  }

  return (
    <SalesPage
      customContent={stagingContent}
      customStyles={stagingStyles}
      isPreview={false}
    />
  );
} 